import { AutopilotSidebar as BaseAutopilotSidebar } from '../AutopilotSidebar/AutopilotSidebar'

export const AutopilotSidebar = () => {
  return (
    <BaseAutopilotSidebar
      sections={[
        {
          heading: 'Why these colors?',
          text: "We've pulled your existing brand colors and recommend alternatives that are proven to increase your social media engagement.",
        },
      ]}
    />
  )
}
